<!--
 * Created by JackCui on 2020/10/14
 -->
<template>
  <el-popover
    popper-class="p-header-process-popover"
    placement="bottom"
    width="412"
    v-model="status.showFlag"
    @hide="hidePopover"
    @show="showPopover"
    trigger="click">
    <process ref="process" :system="system" :limit="limit" @closePopover='closePopover'/>
    <!-- <p class="popover-p" slot="reference" @click.stop="getProcess" title="系统任务进程">
      <img :src="syImgUrl + '/158494734941259971.svg'">
    </p> -->
    <p
      :title="pageText.processTitle"
      class="p-header__process__icon trigger-icon"
      slot="reference"
      @click="popoverShowToggle"
    >
      <i class="iconfont" slot="icon">&#xe78b;</i><slot></slot>
    </p>
  </el-popover>
</template>

<script>
  import Process from './process.vue'
  import { componentMessage } from '../utils'
  import {popoverStatus} from './popover-status.js'
  import i18n from './i18n.js'
  const pageText = window.fe.getPageText(i18n)

  export default {
    name: 'header-process-popover',
    components: {
      Process
    },
    props: {
      show: {
        type: Boolean,
        default: false
      },
      system: {
        type: String,
        default: 'purchaser_web'
      },
      limit: {
        type: Number,
        default: 0
      }
    },
    data () {
      return {
        pageText,
        status: popoverStatus.status
      }
    },
    watch: {
      show (val) {
        popoverStatus[val ? 'show' : 'hide']()
        console.log(this.status, 'popoverStatus')
      }
    },
    created () {
      // 适用端
      let flag = componentMessage(['mall', 'purchaser', 'supplier'], 'header-process-popover 系统任务进程')
      if (flag) return
    },
    methods: {
      // 气泡关闭时触发
      hidePopover () {
        // this.getProcess()
        this.$refs['process'].clearTime()
        this.show = false
        popoverStatus['hide']()
        this.$emit('update:show', this.show)
      },
      // 气泡显示时触发
      showPopover () {
        this.getProcess()
      },
      // 点击任务按钮执行process组件的获取列表方法
      getProcess () {
        this.$refs['process'].fetchData()
      },
      // 关闭气泡
      closePopover () {
        popoverStatus.hide()
      },
      popoverShowToggle () {
        popoverStatus[this.status.showFlag ? 'hide' : 'show']()
      }
    },
    destroyed () {
      popoverStatus.hide()
    }
  }
</script>

<style scoped lang="scss">
</style>
